// extracted by mini-css-extract-plugin
export default {"container":"nonews_container__aan+N","vertical":"nonews_vertical__Voolo","horizontal":"nonews_horizontal__J8wjw","text":"nonews_text__dXXsG"};